function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "ui_instagram_32_svg__a",
  d: "M0 .008h23.992v23.99H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ui_instagram_32_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ui_instagram_32_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.996.249c-3.192 0-3.593.013-4.846.07-1.252.058-2.106.256-2.854.547-.773.3-1.428.702-2.082 1.356A5.762 5.762 0 00.858 4.304C.568 5.052.37 5.906.312 7.157c-.057 1.254-.07 1.654-.07 4.847 0 3.192.013 3.593.07 4.846.057 1.252.256 2.106.546 2.854.3.773.703 1.428 1.356 2.082a5.763 5.763 0 002.082 1.356c.748.29 1.602.489 2.854.546 1.253.057 1.654.07 4.846.07 3.193 0 3.593-.013 4.847-.07 1.251-.057 2.105-.256 2.853-.546a5.763 5.763 0 002.082-1.356 5.763 5.763 0 001.356-2.082c.29-.748.49-1.602.546-2.854.058-1.253.071-1.654.071-4.846 0-3.193-.013-3.593-.07-4.847-.058-1.251-.256-2.105-.547-2.853a5.763 5.763 0 00-1.356-2.082A5.762 5.762 0 0019.696.866c-.748-.29-1.602-.49-2.853-.546-1.254-.058-1.654-.071-4.847-.071zM12 2.008c3.257 0 3.643.012 4.929.07 1.19.055 1.835.254 2.265.42.57.222.976.486 1.402.913.427.427.692.833.913 1.403.167.43.366 1.075.42 2.265.059 1.286.071 1.672.071 4.929 0 3.257-.012 3.642-.071 4.929-.054 1.189-.253 1.835-.42 2.264-.221.57-.486.976-.913 1.403a3.779 3.779 0 01-1.402.912c-.43.168-1.076.366-2.265.42-1.286.06-1.672.072-4.929.072-3.257 0-3.643-.013-4.929-.072-1.19-.054-1.835-.252-2.265-.42a3.779 3.779 0 01-1.402-.912 3.78 3.78 0 01-.913-1.403c-.167-.43-.366-1.075-.42-2.264C2.012 15.65 2 15.265 2 12.007c0-3.256.012-3.642.071-4.928.054-1.19.253-1.836.42-2.265.221-.57.486-.976.913-1.403A3.779 3.779 0 014.806 2.5c.43-.167 1.076-.366 2.265-.42C8.357 2.02 8.743 2.008 12 2.008z",
  fill: "#0A0B09",
  mask: "url(#ui_instagram_32_svg__b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.996 20.003a3.999 3.999 0 110-7.998 3.999 3.999 0 010 7.998zm0-9.87a5.872 5.872 0 100 11.742 5.872 5.872 0 000-11.743zM23.84 9.6a1.44 1.44 0 11-2.88 0 1.44 1.44 0 012.88 0",
  fill: "#0A0B09"
}));

function SvgUiInstagram32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgUiInstagram32;